import moment from "moment";
import * as Yup from "yup"
import Event from "./Event";
import { Attendee, Client, EventPeriod } from "../";

export default class EventRegistration {
    event;
    client;
    attendee;
    period;

    id;
    hash;
    status;
    paid_at;
    price;
    options = [];
    options_price;
    nr_days;
    created_at;

    static fromJson = (json) => {
        let item = new EventRegistration();

        item.event = Event.fromJson(json.event);
        item.client = Client.fromJson(json.client);
        item.attendee = Attendee.fromJson(json.attendee);

        if (json.period) {
            item.period = EventPeriod.fromJson(json.period);
        }

        item.id = json.id;
        item.hash = json.hash;
        item.status = json.status;
        item.paid_at = json.paid_at ? moment(json.paid_at) : null;
        item.price = json.price;
        item.options = json.options || [];
        item.options_price = json.options_price;
        item.nr_days = json.nr_days;

        item.created_at = moment(json.created_at);

        return item;
    }

    // Price without the options
    basePrice = () => (parseFloat(this.price) || 0) - (parseFloat(this.options_price) || 0);

    optionsLabel = () => (this.options || []).map(option => option.title + (option.quantity > 1 ? ' (x' + option.quantity + ')' : '')).join(', ');

    static schema = (settings) => {
        let fields = {
            event: Yup.string().required('CMS.Event.registration.Content.Form.event|select'),
            period: Yup.string().required('CMS.Event.registration.Content.Form.period|select'),
            client: Yup.string().required('CMS.Event.registration.Content.Form.client|select')
        };

        if (settings.use_attendees) {
            fields.attendee = Yup.string().required('CMS.Event.registration.Content.Form.attendee|select');
        }

        return Yup.object(fields);
    }

    static schema_edit = (model, data = {}) => {
        let maxDays = model.nr_days;
        if ('periods' in data && model.period?.id) {
            let period = data.periods.filter(e => e.value === model.period.id)[0];
            maxDays = period?.nr_days;
        }

        return Yup.object({
            event: Yup.string().required('CMS.Event.registration.Content.Form.event'),
            period: Yup.string().required('CMS.Event.registration.Content.Form.period'),
            nr_days: Yup.number().required('CMS.Event.registrations.edit.form.nr_days').min(1, 'CMS.Event.registrations.edit.form.nr_days|1|number_min').max(maxDays, 'CMS.Event.registrations.edit.form.nr_days|' + maxDays + '|number_max'),
        });
    }
}
